import { css } from "@emotion/react"

export const sectorTabsCss = css({
  width: "100%",
  margin: "5px",
})
